export default __webpack_public_path__ + "assets/10eca1f7d5b196dae1aad67ac892aa1d.svg";